import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { DownArrowIcon } from '../StandupIcons';
import TopOpportunitiesTable from '../TopOpportunitiesTable';
import FontFamily from '../../../../constants/fonts';
import { useActionPlanDashboard } from '../../../ActionPlan/hooks/useActionPlanDashboard';
import { useSelectedLocation } from '../../../../hooks/useSelectedLocation';

interface TopOpportunitiesSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  favoriteOpportunities: string[];
  onToggleFavorite: (id: string) => void;
  topOpportunitiesData?: any[];
  onViewDetailsPress?: (item: any) => void;
  isLoadingTopOpportunities?: boolean;
}

export const TopOpportunitiesSection: React.FC<TopOpportunitiesSectionProps> = ({ 
  isExpanded, 
  onToggle, 
  favoriteOpportunities, 
  onToggleFavorite, 
  topOpportunitiesData = [],
  onViewDetailsPress,
  isLoadingTopOpportunities = false, 
}) => {

    const selectedLocation  = useSelectedLocation();
  // Pass Redux data directly to the table component
  // The table will handle the transformation internally

      // Use ActionPlan hook for status change functionality
    const { handleStatusChange } = useActionPlanDashboard(selectedLocation, { 
      isStandup: true, 
      skipCalendarAndFilters: true ,
      topOpportunitiesData: topOpportunitiesData, // Pass current top opportunities data for immediate UI update
    });
  
  return (
    <View style={styles.topOpportunitiesSection}>
      <TouchableOpacity 
        style={styles.topOpportunitiesHeader}
        onPress={onToggle}
        activeOpacity={0.7}
      >
        <View style={styles.topOpportunitiesHeaderContent}>
          <View style={[styles.arrowIconContainer, isExpanded && styles.arrowIconExpanded]}>
            <DownArrowIcon />
          </View>
          <Text style={styles.topOpportunitiesTitle}>Top opportunities</Text>
        </View>
      </TouchableOpacity>
      
      {isExpanded && (
        <View style={styles.topOpportunitiesContent}>
          <TopOpportunitiesTable
            data={topOpportunitiesData}
            onFavoriteToggle={onToggleFavorite}
            isLoading={isLoadingTopOpportunities}
            onViewDetailsPress={onViewDetailsPress}
            onStatusChange={handleStatusChange}
            showFiveRecordsOnly={true} // Custom prop to limit to 5 records, handled inside the table component
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  topOpportunitiesSection: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    // marginTop: 20,
    // marginBottom: 20,
    overflow: 'hidden',
  },
  topOpportunitiesHeader: {
    paddingVertical: 16,
    paddingHorizontal: 20,
    backgroundColor: '#FFFFFF',
  },
  topOpportunitiesHeaderContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  arrowIconContainer: {
    width: 18,
    height: 10,
    justifyContent: 'center',
    alignItems: 'center',
    transform: [{ rotate: '-180deg' }],
  },
  arrowIconExpanded: {
    transform: [{ rotate: '0deg' }],
  },
  topOpportunitiesTitle: {
    fontSize: 28,
    fontStyle: 'normal',
    fontWeight: '700',
    color: '#1C1C1C',
    fontFamily: FontFamily.bold,
    lineHeight: 34,
  },
  topOpportunitiesContent: {
    paddingHorizontal: 20,
    paddingBottom: 20,
  },
});
